module.exports = {
  color: {
    white: "#ffffff",
    turquesa: "#00ffec",
    red: "#bb243a",
    gray: "#2a2f36",
    grayLight: "#333a3f",
    turquesaDark: "#003330",
  },
  size: {
    superSmall: 2,
    small: 4,
    normal: 8,
    big: 16,
    superBig: 32,
  },
  theme: type => {
    if (type == "dark") {
      return {
        white: "#ffffff",
        turquesa: "#00ffec",
        red: "#bb243a",
        gray: "#2a2f36",
        grayLight: "#333a3f",
        turquesaDark: "#003330",
      }
    } else if (type == "light") {
      return {
        white: "#ffffff",
        black: "#000000",
        turquesa: "#1976d2",
        red: "#bb243a",
        gray: "#e8f2fc",
        grayLight: "#ffffff",
        turquesaDark: "#003330",
      }
    }
  },
}
